import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  SubmissionWrapper,
  SubmissionHeader,
  SubmissionPara,
  SubmitButton,
  TickMark,
  TickMarkContainer
} from "./style";
import { showAssistanceDone } from "../action";
import { GeneralButton } from "../../../../../CommonComponents/Commons/commonComponents";

export const NeedAssistanceConfirmComponent = props => {
  return (
    <div className="needAssistance-confirm">
      <SubmissionWrapper>
        <SubmissionHeader>Request Submitted</SubmissionHeader>
        <TickMarkContainer>
          <TickMark />
        </TickMarkContainer>
        <SubmissionPara>
          You have successfully submitted your request for assistance.
          <br /> We will get back to you within 2 - 3 business days.
        </SubmissionPara>
        <GeneralButton
          disabled={false}
          text="DONE"
          type="functional"
          width={"200px"}
          id="btnDone"
          mobWidth="100%"
          inverted = {true}
          onClick={props.assistanceConfirmHandler}
        ></GeneralButton>
      </SubmissionWrapper>
    </div>
  );
};

NeedAssistanceConfirmComponent.propTypes = {
  assistanceConfirmHandler: PropTypes.any
};

const mapDispatchToProps = dispatch => ({
  assistanceConfirmHandler: () => dispatch(showAssistanceDone())
});

export default connect(
  null,
  mapDispatchToProps
)(NeedAssistanceConfirmComponent);
